import { BASE_API_URL } from "api/api.config"
import { Endpoint } from "api/enpoints.types"

export const useQueryTeacherCleverLogin = () => {
  const cleverLoginUrl = `${BASE_API_URL}${Endpoint.TEACHER_LOGIN_CLEVER}`

  const refetch = () => {
    window.location.href = cleverLoginUrl
  }

  return {
    refetch,
  }
}
